﻿import PlanReviewPage from '../PlanReviewPage';

export default function ZhongteStageReviewPage() {
  return <PlanReviewPage reviewDept="zhongte-stage" />;
}